export enum enumAssetManagementPurpose {
  VENDITA = 1,
  MANUTENZIONE = 2,
}
